import {
  UnorderedList
} from "./chunk-3QHKPEXO.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/list/link-list.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var LinkList = forwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx(
      UnorderedList,
      __spreadValues({
        ref,
        className: clsx("hds-list--link-list", className)
      }, rest)
    );
  }
);
LinkList.displayName = "LinkList";

export {
  LinkList
};
//# sourceMappingURL=chunk-OS24UCTD.mjs.map